import { getUTXOAddress } from './getUTXOAddress.js';
export const isUTXOAddress = (address, network) => {
    try {
        const utxoAddress = getUTXOAddress(address);
        if (network) {
            return network === utxoAddress.network;
        }
        return true;
    }
    catch (_error) {
        return false;
    }
};
//# sourceMappingURL=isUTXOAddress.js.map